export default __webpack_public_path__ + "static/media/cms-dropdown.63060b35.svg";